import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/production/final_packing_list_simplified/show_process/${packing_house_process_id}`
    );
  },
  fetchContainers({ packing_house_process_id, current_page, rows_per_page }) {
    return RequesterV1.get(
      `packing_house/production/final_packing_list_simplified/show_process/fetch_containers/${packing_house_process_id}?current_page=${current_page}&rows_per_page=${rows_per_page}`
    );
  },
  fetchPackagesFromStock({
    packing_house_process_id,
    current_page,
    rows_per_page,
  }) {
    return RequesterV1.get(
      `packing_house/production/final_packing_list_simplified/show_process/fetch_packages_from_stock/${packing_house_process_id}?current_page=${current_page}&rows_per_page=${rows_per_page}`
    );
  },
};
